const calaboceroGuard = (to, from, next) => {
  const tipoUsuario = localStorage.getItem("tipo usuario");

  const rolesPermitidos = ["Calabocero", "Super User", "User Tester"];

  if (rolesPermitidos.includes(tipoUsuario)) {
    next();
  } else {
    next("/acceso-denegado");
  }
};

export default calaboceroGuard;
